import React from 'react';
import { Consumer } from 'contexts/Locale/LocaleContext';

export default ConnectedComponent => props => (
    <Consumer>
        {({ state }) => <ConnectedComponent {...props} {...state} />}
    </Consumer>
);
